import type { ArticleInsight } from "../../api/articles";
import { cleanDescription } from "../../lib/description";
import AddToCartButton from "../../components/AddToCartButton";

/**
 * Kopf der Artikelseite (#630): die Bezeichnung ist der Titel, Nummer,
 * Hersteller und Großhändler stehen beschriftet darunter, der Warenkorb rechts.
 */
export function ArticleHero({ article }: { article: ArticleInsight; }) {
  const code = article.primary_article_code ?? article.article_group_key;
  const title = article.description_example ? cleanDescription(article.description_example) : code;
  const facts: Array<{ label: string; value: string; mono?: boolean }> = [
    { label: "Artikelnummer", value: code, mono: true },
    ...(article.brand_name ? [{ label: "Hersteller", value: article.brand_name }] : []),
    ...(article.product_family ? [{ label: "Produktfamilie", value: article.product_family }] : []),
    ...(article.supplier_list ? [{ label: "Großhändler", value: article.supplier_list }] : []),
  ];
  return (
    <header className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0 flex-1 basis-96">
          <h1 className="text-xl font-semibold tracking-tight text-slate-900 sm:text-2xl" title={article.description_example ?? undefined}>
            {title}
          </h1>
          <dl className="mt-3 flex flex-wrap gap-x-8 gap-y-2">
            {facts.map((fact) => (
              <div key={fact.label} className="min-w-0">
                <dt className="text-xs text-slate-500">{fact.label}</dt>
                <dd className={`mt-0.5 text-sm font-medium text-slate-900 ${fact.mono ? "font-mono" : ""}`}>{fact.value}</dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="shrink-0">
          <AddToCartButton articleGroupKey={article.article_group_key} />
        </div>
      </div>
    </header>
  );
}
